<template>
	<div style="position: relative;" @contextmenu.prevent="menuShow" @mouseleave="menuHide">
		<div class="tab_box no-selected flex" :class="{tab_box_active:item.active}" @click="activeTab">
			<div class="tab_title">{{item.title}}</div>
			<i v-if="cancle" class="el-icon-close close" @click.stop="delTab"></i>
		</div>
		<transition name="el-fade-in-linear">
			<ul class="menu no-selected" v-if="menu">
				<li @click="refresh" :class="{disable:($route.path!=item.path)}">刷新</li>
				<li @click="activeTab">选择</li>
				<li @click="delTab" :class="{disable:!cancle}">关闭</li>
				<li @click="closeAll">关闭所有</li>
				<li @click="closeOther" :class="{disable:!cancle}">关闭其他</li>
			</ul>
		</transition>
	</div>
</template>
<style scoped>
	.tab_title {
		display: inline;
	}

	.no-selected {
		-webkit-user-select: none;
		/*Chrome/ Safari/ Opear新版本*/
		-moz-user-select: none;
		/*Foxfire */
		-ms-user-select: none;
		/*Internet Explorer/ Edge*/
		-o-user-select: none;
		/*Opear老版本*/
		-khtml-user-select: none;
		/* Konqueror */
		-webkit-touch-callout: none;
		/* iOS Safari */
		user-select: none;
		/* Nonprefixed version, currently not supported by any browser */
		cursor: pointer;
	}

	.tab_box {
		display: inline-block;
		font-size: 12px;
		flex-direction: row;
		justify-content: space-around;
		align-items: center;
		border: 1px solid #d8dce5;
		padding: 6px 12px;
		margin: 0 4px;
		-webkit-transition: all .2s;
		
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.tab_box:hover {
		border: 1px solid #42b983;
	}

	.tab_box>i {
		margin-left: 15px;
	}

	.tab_box_active {
		background-color: #42b983;
		color: white;
	}

	.close:hover {
		font-weight: bolder;
		color: red;
	}

	ul {
		padding: 0;
		margin: 0;
		list-style: none;
	}

	li {
		padding: 8px 10px;
		font-size: 14px;
		-webkit-transition: all .2s;

	}

	li:hover {
		background-color: #42b983;
		color: white;
	}

	.menu {
		position: absolute;
		background-color: white;
		box-sizing: border-box;
		border: 1px solid #d7dae2;
		width: 80px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
		left: 10px;
	}

	.disable {
		color: #C0C4CC;
	}

	.disable:hover {
		color: #C0C4CC;
		background-color: #D7DAE2;
	}
</style>
<script>
	export default {
		props: {
			item: {
				type: Object,
				required: true
			},
			cancle: {
				type: Boolean,
				default: function() {
					return false
				}
			},
		},
		data() {
			return {
				menu: false
			}
		},
		watch: {

		},
		computed: {
			currentActive() {
				return this.$store.state.main.currentActive
			}
		},

		methods: {
			activeTab() {
				if (this.$router.currentRoute.path != this.item.path) {
					this.$router.push(this.item.path)
				}
				this.menuHide()
			},
			delTab() {
				if (this.cancle) {
					this.$store.commit('main/delTab', {
						path: this.item.path
					})
					this.menuHide()
				}
			},
			menuShow() {
				this.menu = true
			},
			menuHide() {
				this.menu = false
			},
			closeAll() {
				this.$store.commit('main/closeAll')
				this.menuHide()
			},
			closeOther() {
				if (this.cancle) {
					this.$store.commit('main/closeOther', {
						path: this.item.path
					})
					this.menuHide()
				}
			},
			refresh() {
				if (this.$route.path == this.item.path) {
					this.menuHide()
					this.$route.meta.timeStamp = Math.random()
				}
			}
		}
	}
</script>
